/**
 * @generated SignedSource<<5dede043b754e8a51b70a348ceb1d4d6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type subSectionIndexArticleListPaginationQuery$variables = {
  after?: string | null | undefined;
  first?: number | null | undefined;
  id: string;
};
export type subSectionIndexArticleListPaginationQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"subSectionIndexArticleList">;
  } | null | undefined;
};
export type subSectionIndexArticleListPaginationQuery = {
  response: subSectionIndexArticleListPaginationQuery$data;
  variables: subSectionIndexArticleListPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": 23,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlAlias",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v10 = [
  (v9/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v12 = [
  (v11/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "description",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "Newsletter",
  "kind": "LinkedField",
  "name": "relatedNewsletters",
  "plural": true,
  "selections": [
    (v5/*: any*/),
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alternativeName",
      "storageKey": null
    },
    (v13/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "summary",
      "plural": false,
      "selections": (v12/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "homepageDescription",
      "plural": false,
      "selections": (v12/*: any*/),
      "storageKey": null
    },
    (v4/*: any*/)
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityUuid",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "UrlRedirect",
  "kind": "LinkedField",
  "name": "urlRedirect",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "toUrl",
      "storageKey": null
    },
    (v4/*: any*/)
  ],
  "storageKey": null
},
v17 = [
  (v5/*: any*/),
  (v4/*: any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "Application",
  "kind": "LinkedField",
  "name": "application",
  "plural": false,
  "selections": (v17/*: any*/),
  "storageKey": null
},
v19 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "fullSectionPath",
      "plural": true,
      "selections": (v17/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parentSection",
      "storageKey": null
    }
  ],
  "type": "Section",
  "abstractKey": null
},
v20 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "disableFollow",
    "storageKey": null
  }
],
v21 = {
  "alias": "articleTypes",
  "args": null,
  "concreteType": "ArticleTypeSegment",
  "kind": "LinkedField",
  "name": "types",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleType",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": (v17/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sponsorType",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "PaywallType",
  "kind": "LinkedField",
  "name": "paywallTypes",
  "plural": true,
  "selections": [
    (v15/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v24 = {
  "kind": "InlineFragment",
  "selections": [
    (v21/*: any*/),
    (v22/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "SectionSegment",
      "kind": "LinkedField",
      "name": "sections",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Section",
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": (v17/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v23/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "json",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegment",
  "kind": "LinkedField",
  "name": "sections",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v5/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "subSectionIndexArticleListPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "FragmentSpread",
            "name": "subSectionIndexArticleList"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "subSectionIndexArticleListPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v5/*: any*/),
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Topic",
                                "kind": "LinkedField",
                                "name": "topics",
                                "plural": true,
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Sponsor",
                                    "kind": "LinkedField",
                                    "name": "sponsor",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v8/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Image",
                                        "kind": "LinkedField",
                                        "name": "images",
                                        "plural": true,
                                        "selections": (v10/*: any*/),
                                        "storageKey": null
                                      },
                                      (v4/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v4/*: any*/),
                                  (v14/*: any*/),
                                  (v6/*: any*/),
                                  (v7/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v3/*: any*/),
                                      (v15/*: any*/),
                                      (v16/*: any*/),
                                      (v18/*: any*/),
                                      (v19/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v20/*: any*/),
                                        "type": "Author",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v20/*: any*/),
                                        "type": "Topic",
                                        "abstractKey": null
                                      },
                                      (v24/*: any*/)
                                    ],
                                    "type": "BaseWithApplicationAndUrlAlias",
                                    "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "createdDate",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "updatedDate",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "publishedDate",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Image",
                                "kind": "LinkedField",
                                "name": "images",
                                "plural": true,
                                "selections": [
                                  (v9/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "title",
                                    "storageKey": null
                                  },
                                  (v8/*: any*/),
                                  {
                                    "alias": "size1200x800",
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": {
                                          "style": "1200x800"
                                        }
                                      }
                                    ],
                                    "concreteType": "ImageStyle",
                                    "kind": "LinkedField",
                                    "name": "style",
                                    "plural": false,
                                    "selections": (v10/*: any*/),
                                    "storageKey": "style(filter:{\"style\":\"1200x800\"})"
                                  },
                                  {
                                    "alias": "size540x360",
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": {
                                          "style": "540x360"
                                        }
                                      }
                                    ],
                                    "concreteType": "ImageStyle",
                                    "kind": "LinkedField",
                                    "name": "style",
                                    "plural": false,
                                    "selections": (v10/*: any*/),
                                    "storageKey": "style(filter:{\"style\":\"540x360\"})"
                                  },
                                  {
                                    "alias": "landscape250x99",
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": {
                                          "style": "landscape_250_99"
                                        }
                                      }
                                    ],
                                    "concreteType": "ImageStyle",
                                    "kind": "LinkedField",
                                    "name": "style",
                                    "plural": false,
                                    "selections": (v10/*: any*/),
                                    "storageKey": "style(filter:{\"style\":\"landscape_250_99\"})"
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "headline",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "socialHeadline",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "flag",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SectionSegment",
                                "kind": "LinkedField",
                                "name": "sections",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Section",
                                    "kind": "LinkedField",
                                    "name": "value",
                                    "plural": true,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v4/*: any*/),
                                      (v14/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v3/*: any*/),
                                          (v5/*: any*/),
                                          (v15/*: any*/),
                                          (v6/*: any*/),
                                          (v16/*: any*/),
                                          (v18/*: any*/),
                                          (v19/*: any*/),
                                          (v24/*: any*/)
                                        ],
                                        "type": "BaseWithApplicationAndUrlAlias",
                                        "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FormattedValue",
                                "kind": "LinkedField",
                                "name": "subHeadline",
                                "plural": false,
                                "selections": [
                                  (v25/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FormattedValue",
                                "kind": "LinkedField",
                                "name": "summary",
                                "plural": false,
                                "selections": [
                                  (v25/*: any*/),
                                  (v11/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "shortUrl",
                                "storageKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v15/*: any*/),
                                  (v16/*: any*/),
                                  (v18/*: any*/),
                                  (v19/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v21/*: any*/),
                                      (v22/*: any*/),
                                      (v26/*: any*/),
                                      (v23/*: any*/)
                                    ],
                                    "type": "Article",
                                    "abstractKey": null
                                  }
                                ],
                                "type": "BaseWithApplicationAndUrlAlias",
                                "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "flattenTypeIds",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LiveArticle",
                                    "kind": "LinkedField",
                                    "name": "liveArticle",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "status",
                                        "storageKey": null
                                      },
                                      (v4/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v22/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "commentCount",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "hasVideoContent",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ArticleTypeSegment",
                                    "kind": "LinkedField",
                                    "name": "types",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ArticleType",
                                        "kind": "LinkedField",
                                        "name": "value",
                                        "plural": true,
                                        "selections": [
                                          (v7/*: any*/),
                                          (v5/*: any*/),
                                          (v13/*: any*/),
                                          (v4/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v26/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Author",
                                    "kind": "LinkedField",
                                    "name": "authors",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "types",
                                        "storageKey": null
                                      },
                                      (v4/*: any*/),
                                      (v5/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v14/*: any*/)
                                ],
                                "type": "Article",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "duration",
                                    "storageKey": null
                                  },
                                  (v26/*: any*/)
                                ],
                                "type": "Video",
                                "abstractKey": null
                              }
                            ],
                            "type": "Content",
                            "abstractKey": "__isContent"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v4/*: any*/)
                            ],
                            "type": "Node",
                            "abstractKey": "__isNode"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v2/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "subSectionIndexArticleListQuery__items",
                "kind": "LinkedHandle",
                "name": "items"
              }
            ],
            "type": "Queue",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "85235fcdedc3d836c2c1c0bc65f2df72",
    "id": null,
    "metadata": {},
    "name": "subSectionIndexArticleListPaginationQuery",
    "operationKind": "query",
    "text": "query subSectionIndexArticleListPaginationQuery(\n  $after: String\n  $first: Int = 23\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...subSectionIndexArticleList_2HEEH6\n    id\n  }\n}\n\nfragment articleCommentArticle on Article {\n  ...entityLink\n  commentCount\n  entityId\n}\n\nfragment blockquoteQuoteContent on Content {\n  __isContent: __typename\n  ...contentShareWidgetContent\n}\n\nfragment checkersCheckContentContainsStarlingImageContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment contentActionBarContent on Content {\n  __isContent: __typename\n  entityId\n  createdDate\n  updatedDate\n  publishedDate\n  ...articleCommentArticle\n  ... on Article {\n    hasVideoContent\n  }\n}\n\nfragment contentCoverImageContent_2m5Gjt on Content {\n  __isContent: __typename\n  images {\n    url\n    title\n    type\n    size1200x800: style(filter: {style: \"1200x800\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_34Njms on Content {\n  __isContent: __typename\n  images {\n    url\n    title\n    type\n    landscape250x99: style(filter: {style: \"landscape_250_99\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentHeadlineContent on Content {\n  __isContent: __typename\n  headline\n  socialHeadline\n  ...contentHeadlineTagContent\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentHeadlineTagContent on Content {\n  __isContent: __typename\n  ...hooksContentHeadlineTagContent\n}\n\nfragment contentLiveTagContent on Article {\n  ...helpersCheckHasLiveTagArticle\n}\n\nfragment contentNewsletterWidgetContent on Content {\n  __isContent: __typename\n  topics {\n    relatedNewsletters {\n      ...helpersMassageToNewsletterItemNewsletter\n      id\n    }\n    id\n  }\n  sections {\n    value {\n      relatedNewsletters {\n        ...helpersMassageToNewsletterItemNewsletter\n        id\n      }\n      id\n    }\n  }\n  ... on Article {\n    relatedNewsletters {\n      ...helpersMassageToNewsletterItemNewsletter\n      id\n    }\n  }\n}\n\nfragment contentSchemaRenderContent on Content {\n  __isContent: __typename\n  ...blockquoteQuoteContent\n  ...imageContent\n  ...inlineWidgetContent\n  ...photoGalleryWidgetContent\n  ...scmpYoutubeContent\n}\n\nfragment contentSectionsContent on Content {\n  __isContent: __typename\n  sections {\n    value {\n      ...helpersCheckIfNewsSectionInFirstIndexSection\n      ...entityLink\n      name\n      id\n    }\n  }\n}\n\nfragment contentShareWidgetContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  shortUrl\n  socialHeadline\n  headline\n}\n\nfragment contentSponsorTagContent on Content {\n  __isContent: __typename\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentSubHeadlineContent on Content {\n  __isContent: __typename\n  subHeadline {\n    json\n  }\n  summary {\n    json\n  }\n  ...contentSchemaRenderContent\n}\n\nfragment contentSummaryContent on Content {\n  __isContent: __typename\n  __typename\n  summary {\n    text\n  }\n}\n\nfragment contentTopicLinkContent on Content {\n  __isContent: __typename\n  topics {\n    urlAlias\n    ...entityLink\n    ...topicLinkTopic\n    id\n  }\n}\n\nfragment entityFollowButtonBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Section {\n    entityId\n    name\n  }\n  ... on Author {\n    entityId\n    name\n    disableFollow\n  }\n  ... on Topic {\n    entityId\n    name\n    disableFollow\n  }\n}\n\nfragment entityLink on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  entityId\n  entityUuid\n  urlAlias\n  urlRedirect {\n    toUrl\n    id\n  }\n  application {\n    entityId\n    id\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      id\n    }\n    parentSection\n  }\n  ...helpersAppBarVariantBase\n  ...helpersApplicationBase\n  ...helpersCheckIsPlusArticle\n  ...helpersStyleSectionContent\n}\n\nfragment followButtonBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...entityFollowButtonBase\n  entityId\n}\n\nfragment helpersAppBarVariantBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsLongReadArticle\n  ...helpersCheckIsMorningStudioArticle\n  ...helpersCheckIsPhotoEssayArticle\n  ...helpersCheckIsPostiesArticle\n  ...helpersCheckIsPostiesPage\n  ...helpersCheckIsStyleArticle\n  ...helpersSectionContent\n  ...helpersStyleSectionContent\n  ...helpersCheckIsPlusPage\n}\n\nfragment helpersApplicationBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsPostiesArticle\n  ...helpersCheckIsPostiesPage\n  ...helpersCheckIsPlusPage\n}\n\nfragment helpersCheckHasLiveTagArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckIfNewsSectionInFirstIndexSection on Section {\n  name\n}\n\nfragment helpersCheckIsLongReadArticle on Article {\n  articleTypes: types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsMainTopicContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment helpersCheckIsMorningStudioArticle on Article {\n  sponsorType\n  articleTypes: types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPhotoEssayArticle on Article {\n  articleTypes: types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPlusArticle on Article {\n  paywallTypes {\n    entityUuid\n    id\n  }\n}\n\nfragment helpersCheckIsPlusPage on Page {\n  urlAlias\n}\n\nfragment helpersCheckIsPostiesArticle on Article {\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPostiesPage on Page {\n  urlAlias\n}\n\nfragment helpersCheckIsStyleArticle on Article {\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersMassageToNewsletterItemNewsletter on Newsletter {\n  entityId\n  name\n  alternativeName\n  description {\n    text\n  }\n  summary {\n    text\n  }\n  homepageDescription {\n    text\n  }\n}\n\nfragment helpersSanitizeArticleTypeEntityIdsArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersSanitizeAuthorTypesArticle on Article {\n  authors {\n    types\n    id\n  }\n}\n\nfragment helpersSanitizedAuthorEntityIdsArticle on Article {\n  authors {\n    entityId\n    id\n  }\n}\n\nfragment helpersSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersStyleSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersUseContentSponsorContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    sponsor {\n      ...sponsorTagSponsor\n      name\n      type\n      id\n    }\n    id\n  }\n  ... on Article {\n    sponsorType\n  }\n  ...helpersCheckIsMainTopicContent\n}\n\nfragment homePrimaryContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...helpersCheckHasLiveTagArticle\n  ...hooksContentItemProvidersContent_3FSKiH\n}\n\nfragment homeSecondaryContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...helpersCheckHasLiveTagArticle\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_3VksLb\n}\n\nfragment hooksContentHeadlineTagContent on Content {\n  __isContent: __typename\n  ... on Article {\n    types {\n      value {\n        name\n        entityId\n        description {\n          text\n        }\n        id\n      }\n    }\n    ...helpersCheckIsStyleArticle\n  }\n  flag\n  sections {\n    value {\n      name\n      id\n    }\n  }\n  ...hooksContentHelperContent\n}\n\nfragment hooksContentHelperContent on Content {\n  __isContent: __typename\n  ...helpersSanitizeArticleTypeEntityIdsArticle\n  ...helpersSanitizeAuthorTypesArticle\n  ...helpersSanitizedAuthorEntityIdsArticle\n  flag\n}\n\nfragment hooksContentItemProvidersContent_3FSKiH on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentCoverImageContent_2m5Gjt\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSectionsContent\n  ...contentSummaryContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n}\n\nfragment hooksContentItemProvidersContent_3TpHBe on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentHeadlineContent\n  ...contentSectionsContent\n  ...contentSubHeadlineContent\n  ...contentSummaryContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n}\n\nfragment hooksContentItemProvidersContent_3VksLb on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentCoverImageContent_2m5Gjt\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSectionsContent\n  ...contentSubHeadlineContent\n  ...contentSummaryContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n}\n\nfragment imageContent on Content {\n  __isContent: __typename\n  headline\n  ...checkersCheckContentContainsStarlingImageContent\n}\n\nfragment inlineWidgetContent on Content {\n  __isContent: __typename\n  ...contentNewsletterWidgetContent\n}\n\nfragment oneSectionTopWidgetQueue on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      ...homeSecondaryContentItemContent\n      ...sectionTopLeadPrimaryContentItemContent\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment photoGalleryDialogContent on Content {\n  __isContent: __typename\n  __typename\n  ...contentShareWidgetContent\n}\n\nfragment photoGalleryWidgetContent on Content {\n  __isContent: __typename\n  ...photoGalleryDialogContent\n}\n\nfragment scmpYoutubeContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  publishedDate\n}\n\nfragment sectionTopLeadPrimaryContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  topics {\n    ...followButtonBase\n    id\n  }\n  ...entityLink\n  ...contentCoverImageContent_34Njms\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_3TpHBe\n}\n\nfragment sponsorTagSponsor on Sponsor {\n  name\n  type\n  images {\n    url\n  }\n}\n\nfragment subSectionIndexArticleList_2HEEH6 on Queue {\n  items(first: $first, after: $after) {\n    edges {\n      ...oneSectionTopWidgetQueue\n      ...topStoriesBlockQueueItemsEdge\n      cursor\n      node {\n        __typename\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment topStoriesBlockQueueItemsEdge on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      ...topStoriesItemContent\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment topStoriesItemContent on Content {\n  __isContent: __typename\n  ...homePrimaryContentItemContent\n  ...homeSecondaryContentItemContent\n  ...helpersUseContentSponsorContent\n}\n\nfragment topicLinkTopic on Topic {\n  ...entityLink\n  name\n}\n\nfragment videoDurationOverlayVideo on Video {\n  duration\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ebcc37b97296aad88bab9ade689d9414";

export default node;
